import React from 'react';
import { BaseResourceListProps, SimpleList, SvgBin, SvgEdit } from '@app/components';
import { paymentProviderApi } from '@app/store';
import { IPaymentProvider, PaymentProvider } from '@app/common';
import { theme } from '@app/theme';
import { createColumnHelper } from '@tanstack/react-table';
import { useTable } from '@app/hooks/useTable';
import { CheckPermissions } from '@app/components/CheckPermissions';

const columnHelper = createColumnHelper<IPaymentProvider>();

const getProviderIdentifier = (provider: IPaymentProvider): string => {
  if (provider.type === PaymentProvider.WORLDLINE) {
    return (provider as any).merchantId || '-';
  }
  return (provider as any).rootShopId || '-';
};

export const PaymentProviderList = ({ onUpdate, onDelete, onRowPress, selectedRowItem }: BaseResourceListProps<IPaymentProvider>) => {
  const columns = [
    columnHelper.display({
      id: 'identifier',
      header: () => (
        <SimpleList.HeaderItem width="40%">
          <SimpleList.HeaderItemLabel>Identifiant</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => {
        return (
          <SimpleList.ItemCol width="40%">
            <SimpleList.ItemImageWrapper>
              <SimpleList.ItemText align="left" bold numberOfLines={2} active={info.active}>
                {getProviderIdentifier(info.row.original)}
              </SimpleList.ItemText>
            </SimpleList.ItemImageWrapper>
          </SimpleList.ItemCol>
        );
      },
    }),
    columnHelper.accessor('type', {
      header: () => (
        <SimpleList.HeaderItem width="35%">
          <SimpleList.HeaderItemLabel>Prestataire</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => {
        return (
          <SimpleList.ItemCol width="35%">
            <SimpleList.ItemImageWrapper>
              <SimpleList.ItemText align="left" bold numberOfLines={2} active={info.active}>
                {info.getValue()}
              </SimpleList.ItemText>
            </SimpleList.ItemImageWrapper>
          </SimpleList.ItemCol>
        );
      },
    }),
    columnHelper.display({
      id: 'actions',
      header: () => (
        <SimpleList.HeaderItem width="25%" align='center'>
          <SimpleList.HeaderItemLabel>Actions</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: ({ row, active }) => (
        <SimpleList.ItemCol width="25%">
          <SimpleList.ItemActions>
            <CheckPermissions permissions={['dashboard::payment-providers.update']}>
              <SimpleList.ItemAction onPress={() => onUpdate(row.original)}>
                <SvgEdit color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>

            <CheckPermissions permissions={['dashboard::payment-providers.delete']}>
              <SimpleList.ItemAction onPress={() => onDelete(row.original)}>
                <SvgBin color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>
          </SimpleList.ItemActions>
        </SimpleList.ItemCol>
      ),
    }),
  ];

  const { table, setSearch, isFetching } = useTable({
    columns,
    useQuery: ({ pagination, search }) => paymentProviderApi.useReadManyPaymentProvidersQuery({
      pagination,
      sort: ['createdAt:ASC'],
    })
  });

  return (
    <SimpleList
      table={table}
      isFetching={isFetching}
      onSearch={setSearch}
      selectedRowItem={selectedRowItem}
      onRowPress={onRowPress} />
  )

};
